import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class packageTrackService {
  constructor(private http:HttpClient) { }

  

  getPackageById(data:any){
    return this.http.post(environment.apiUrl + "packages/get/byId" , data)
  }
}